module.exports = __webpack_public_path__ + "static/media/1s.33d5c0d2.png";